import { sections } from '#packages/util';
import type {
  MapDispatchToProps,
  MapStateToProps,
  ThunkAction,
} from 'types/redux';
import type { LimitlessZoomOwnProps } from './limitlessZoom';

export interface ZoomDispatchProps {
  enterZoomMode: (scale?: number) => void;
}

export interface LimitlessZoomStateProps {
  isZoomOutMode: boolean;
  isSectionsEnabled: boolean;
  siteScale: number;
  isStageShifted: boolean;
}
export const mapStateToProps: MapStateToProps<
  LimitlessZoomStateProps,
  LimitlessZoomOwnProps
> = ({ editorAPI }) => ({
  isZoomOutMode: editorAPI.zoomMode.isInZoomMode(),
  isSectionsEnabled: sections.isSectionsEnabled(),
  siteScale: editorAPI.getSiteScale(),
  isStageShifted: editorAPI.zoomMode.isShrinkedStageZoomOutActive(),
});

export const mapDispatchToProps: MapDispatchToProps<
  ZoomDispatchProps,
  LimitlessZoomOwnProps
> = {
  enterZoomMode:
    (scale: number): ThunkAction =>
    (_dispatch, _getState, { editorAPI }) => {
      editorAPI.zoomMode.enterZoomMode({
        biParams: { origin: 'topbar' },
        clickedByUser: true,
        zoomScale: scale,
      });
    },
};
